/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];

    const project = feature.project;
    const NAME = feature.getSettingValue('NAME');
    const I2C = feature.getSettingValue('I2C');
    const TEMP = feature.getSettingValue('TEMPERATURE');
    if (!I2C) {
        return blocks;
    }
    const I2CFeature = project.getFeature(I2C);

    blocks.push({
        location: 'PRJ_CONF',
        id: 'CONFIG_SENSOR=y',
        template: `
CONFIG_SENSOR=y`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.CODE,
        id: '#include <zephyr/drivers/sensor.h>',
        template: '#include <zephyr/drivers/sensor.h>',
    });

    blocks.push({
        location: 'APP_OVERLAY',
        template: `
&${I2CFeature.getSettingValue('PORT')} {
    status = "okay";

    ${NAME}: mcp9808@18 {
        compatible = "microchip,mcp9808";
        reg = <0x18>;
        // int-gpios = <&gpio0 26 (GPIO_PULL_UP | GPIO_ACTIVE_LOW)>;
    };
};
        `,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        template: `
const struct device *const ${NAME}_dev = DEVICE_DT_GET(DT_NODELABEL(${NAME}));`,
    });

    blocks.push({
        location: 'boot',
        template: `
if (${NAME}_dev == NULL) {
    printf("Device not found.\\n");
    // return 0;
}
if (!device_is_ready(${NAME}_dev)) {
    printf("Device %s is not ready.\\n", ${NAME}_dev->name);
    // return 0;
}`,
    });

    blocks.push({
        location: `var_${TEMP}_update`,
        template: `
int rc = sensor_sample_fetch(${NAME}_dev);
if (rc != 0) {
    printf("sensor_sample_fetch error: %d\\n", rc);
    // break;
}

struct sensor_value temp;

rc = sensor_channel_get(${NAME}_dev, SENSOR_CHAN_AMBIENT_TEMP, &temp);
if (rc != 0) {
    printf("sensor_channel_get error: %d\\n", rc);
    // break;
}

var_${TEMP}_set((float)sensor_value_to_double(&temp));
        `,
    });

    return blocks;
};
